module.exports = __webpack_public_path__ + "static/media/plan-401.e925cff8.svg";